import { render } from "./CellphoneResetPassword.vue?vue&type=template&id=34d85c16"
import script from "./CellphoneResetPassword.vue?vue&type=script&lang=js"
export * from "./CellphoneResetPassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/panelapi-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__